import { useState } from "react";
import Messages from "../../Modules/Messages";
import SideMenu from "../../Modules/SideMenu";
import ChatSearch from "../../common/components/ChatSearch";
import ChatWindowWrapper from "../../common/components/ChatWindowWrapper";
import Loader from "../../common/components/Loader";
import Themes from "../../common/components/Themes";
import styles from "./Admin.module.scss";
import {
  API_ROUTES,
  INITAL_TRAIN_DATAS,
  VERIFY_AUTHENTICATION_STATUS,
} from "../../common/constants";
import { Toaster, toast } from "react-hot-toast";
import { fetchInformation } from "../../common/services/api.services";

const Admin = () => {
  const [datas, setDatas] = useState(INITAL_TRAIN_DATAS);
  const [loader, setLoader] = useState(false);
  const loggedIn = VERIFY_AUTHENTICATION_STATUS;
  const [inputValue, setInputValue] = useState("");

  const onSubmit = async (inputValue: string) => {
    if (inputValue) {
      try {
        setLoader(true);
        const responses = await fetchInformation(inputValue, API_ROUTES.TRAIN);
        const apiData = responses?.data;
        setDatas([{ id: 1, user: inputValue, response: apiData }]);
      } catch (e) {
        console.log(e);
        toast.error("Somthing went wrong, please try again");
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Please enter necessary input");
    }
  };

  const handleChangeChatSearch = (value: any) => {
    setInputValue(value);
  };

  return (
    <Themes>
      <Toaster />
      <section>
        <div className={styles.flex}>
          <div className={styles.desktopSideMenu}>
            <SideMenu />
          </div>
          <ChatWindowWrapper>
            <ChatSearch
              searchValue={inputValue}
              handleChangeChatSearch={handleChangeChatSearch}
              placeholder={""}
              loader={loader}
              loggedIn={loggedIn}
              onSubmitFn={onSubmit}
            />
            {loader && <Loader />}
            {!loader && <Messages contentArray={datas} />}
          </ChatWindowWrapper>
        </div>
        <div className={styles.bottomSideMenu}>
          <SideMenu />
        </div>
      </section>
    </Themes>
  );
};

export default Admin;
